class FilterManager {
  constructor(container) {
    this.container = container;
    this.filterCheckboxes = container.querySelectorAll('input[type="checkbox"][data-filter]');
    this.items = container.querySelectorAll('[data-filter-item]');
    this.countElement = container.querySelector('[data-filter-count]');
    this.filterTitles = container.querySelectorAll('[data-filter-title]');
    this.noResultsMessage = container.querySelector('[data-filter-no-results]');
    this.singularText = container.getAttribute('data-filter-singular');
    this.pluralText = container.getAttribute('data-filter-plural');
    
    this.init();
  }

  init() {
    if (0 === this.filterCheckboxes.length || 0 === this.items.length) {
      return;
    }

    this.updateCount(this.items.length);
    this.bindEvents();
  }

  bindEvents() {
    this.filterTitles.forEach(title => {
      title.addEventListener('click', () => this.toggleFilterDropdown(title));
    });

    this.filterCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', () => this.filterItems());
    });
  }

  toggleFilterDropdown(title) {
    title.classList.toggle('active');
    title.nextElementSibling?.classList.toggle('active');
  }

  getCheckedFilters() {
    const checkedFilters = {};
    
    this.filterCheckboxes.forEach(checkbox => {
      if (!checkbox.checked) {
        return;
      }

      const filterType = checkbox.getAttribute('data-filter');
      const filterValue = checkbox.getAttribute('data-value').toLowerCase();
        
      if (!checkedFilters[filterType]) {
        checkedFilters[filterType] = [];
      }
      
      checkedFilters[filterType].push(filterValue);
    });
    
    return checkedFilters;
  }

  filterItems() {
    const checkedFilters = this.getCheckedFilters();
    const hasActiveFilters = 0 <Object.keys(checkedFilters).length;
    
    if (!hasActiveFilters) {
      this.showAllItems();
      return;
    }

    let visibleCount = 0;

    this.items.forEach(item => {
      const shouldShow = this.shouldShowItem(item, checkedFilters);
      
      item.classList.toggle('hidden', !shouldShow);
      
      if (!shouldShow) {
        return;
      }

      visibleCount++;
    });

    this.updateCount(visibleCount);
    this.toggleNoResultsMessage(0 === visibleCount);
  }

  shouldShowItem(item, checkedFilters) {
    for (const filterType in checkedFilters) {
      const checkedValues = checkedFilters[filterType];
      const itemMatches = this.itemMatchesFilterGroup(item, filterType, checkedValues);

      if (!itemMatches) {
        return false;
      }
    }

    return true;
  }

  itemMatchesFilterGroup(item, filterType, checkedValues) {
    if (0 === checkedValues.length) {
      return true;
    }

    const itemValuesStr = item.getAttribute(`data-${filterType}`)?.toLowerCase() || '';
    const itemValues = itemValuesStr.split(' ').filter(Boolean);

    return checkedValues.some(checkedValue => itemValues.includes(checkedValue));
  }

  showAllItems() {
    this.items.forEach(item => {
      item.classList.remove('hidden');
    });

    this.updateCount(this.items.length);
    this.toggleNoResultsMessage(false);
  }

  updateCount(count) {
    if (!this.countElement) {
      return;
    };
    
    this.countElement.textContent = count;
    this.updateCountText(count);
  }

  updateCountText(count) {
    if (!this.singularText || !this.pluralText) {
      return;
    }
    
    const countContainer = this.countElement.parentElement;
    if (!countContainer) {
      return;
    }
    
    Array.from(countContainer.childNodes).forEach(node => {
      if (node.nodeType === Node.TEXT_NODE || (node.nodeType === Node.ELEMENT_NODE && node !== this.countElement)) {
        countContainer.removeChild(node);
      }
    });
    
    countContainer.appendChild(
      document.createTextNode(` ${1 === count ? this.singularText : this.pluralText}`)
    );
  }

  toggleNoResultsMessage(show) {
    if (!this.noResultsMessage) {
      return;
    }

    this.noResultsMessage.classList.toggle('hidden', !show);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const filterContainers = document.querySelectorAll('[data-filter-container]');
  
  filterContainers.forEach(container => {
    new FilterManager(container);
  });
});
